import React from 'react';

const Header = () => {
  return (
    <header className="fixed top-0 w-full bg-white shadow-md z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex-shrink-0">
            <a href="#intro" className="text-2xl font-bold text-gray-900">
              KADIBIA BEAUTY
            </a>
          </div>
          
          <nav className="hidden md:block">
            <ul className="flex space-x-8">
              <li><a href="#intro" className="text-gray-700 hover:text-gray-900 transition-colors">Home</a></li>
              <li><a href="#about" className="text-gray-700 hover:text-gray-900 transition-colors">About</a></li>
              <li><a href="#works" className="text-gray-700 hover:text-gray-900 transition-colors">Services</a></li>
              <li><a href="#footer" className="text-gray-700 hover:text-gray-900 transition-colors">Contact</a></li>
            </ul>
          </nav>
          
          <button className="md:hidden">
            <span className="text-gray-700">Menu</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;